module.exports = __webpack_public_path__ + "img/cpf-icon.343d03fd.svg";